import React from 'react';

interface ProductCardProps {
  title: string;
  imageUrl: string;
  affiliateUrl: string;
  description?: string;
}

const ProductCard: React.FC<ProductCardProps> = ({ title, imageUrl, affiliateUrl, description }) => {
  return (
    <div className="product-card">
      <a
        href={affiliateUrl}
        target="_blank"
        rel="noopener noreferrer"
        className="product-card-link"
        aria-label={`View ${title} on Amazon`}
      >
        <div className="product-card-image">
          <img src={imageUrl} alt={title} loading="lazy" />
        </div>
        <div className="product-card-content">
          <h4 className="product-card-title">{title}</h4>
          {description && <p className="product-card-description">{description}</p>}
          <span className="product-card-cta">View on Amazon →</span>
        </div>
      </a>
    </div>
  );
};

export default ProductCard;
